import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';

// project import
// import NavUser from 'src/components/NavUser';
// import NavCard from 'src/components/NavCard';
// import Navigation from 'src/components/Navigation';
import SimpleBar from 'src/components/ui/SimpleBar';
import useInterface from 'src/hooks/useInterface';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = (props) => {
	const {
		drawerOpen: drawerOpenProps,
		NavigationRP,
		NavCardRP,
		NavUserRP,
	} = props;

	const { isDrawerOpen } = useInterface();
	const drawerOpen =
		drawerOpenProps === undefined ? isDrawerOpen : drawerOpenProps;

	const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
	const isCardAvail = drawerOpen && !downLG;

	return (
		<>
			<SimpleBar
				sx={{
					'& .simplebar-content': { display: 'flex', flexDirection: 'column' },
				}}
			>
				{NavigationRP && <NavigationRP />}
				{NavCardRP && isCardAvail && <NavCardRP />}
			</SimpleBar>
			{NavUserRP && <NavUserRP />}
		</>
	);
};

DrawerContent.propTypes = {
	drawerOpen: PropTypes.bool,
	NavigationRP: PropTypes.elementType,
	NavCardRP: PropTypes.elementType,
	NavUserRP: PropTypes.elementType,
};

export default DrawerContent;
